"use strict";
var ɵngcc0 = require('@angular/core');
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var sidebar_component_1 = require("./sidebar.component");
var CloseSidebar = /** @class */ (function () {
    function CloseSidebar(_sidebar) {
        this._sidebar = _sidebar;
    }
    /** @internal */
    CloseSidebar.prototype._onClick = function () {
        if (this._sidebar) {
            this._sidebar.close();
        }
    };
    CloseSidebar = __decorate([ __metadata("design:paramtypes", [sidebar_component_1.Sidebar])
    ], CloseSidebar);
CloseSidebar.ɵfac = function CloseSidebar_Factory(t) { return new (t || CloseSidebar)(ɵngcc0.ɵɵdirectiveInject(sidebar_component_1.Sidebar)); };
CloseSidebar.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: CloseSidebar, selectors: [["", "closeSidebar", ""]], hostBindings: function CloseSidebar_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function CloseSidebar_click_HostBindingHandler($event) { return ctx._onClick(); });
    } } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CloseSidebar, [{
        type: core_1.Directive,
        args: [{
                selector: '[closeSidebar]',
                host: {
                    '(click)': '_onClick()'
                }
            }]
    }], function () { return [{ type: sidebar_component_1.Sidebar }]; }, null); })();
    return CloseSidebar;
}());
exports.CloseSidebar = CloseSidebar;

//# sourceMappingURL=close.directive.js.map